import React, { Component } from 'react';
import { MegadraftPlugin, MegadraftIcons } from 'megadraft';
import UploadManagerModal from './UploadManagerModal';
import { find, get, cloneDeep } from 'lodash';
import { UploaderView } from './UploaderView.styles';
const { BlockContent, CommonBlock } = MegadraftPlugin;

class Left extends Component {
  render() {
    return <div className={``}>L</div>;
  }
}

class Right extends Component {
  render() {
    return <div className={``}>R</div>;
  }
}

class Center extends Component {
  render() {
    return <div className={``}>C</div>;
  }
}

class Contain extends Component {
  render() {
    return <div className={``}>Contain</div>;
  }
}

class Cover extends Component {
  render() {
    return <div>Cover</div>;
  }
}

class Large extends Component {
  render() {
    return <div>Large</div>;
  }
}

class Medium extends Component {
  render() {
    return <div>Medium</div>;
  }
}

class Small extends Component {
  render() {
    return <div>Small</div>;
  }
}

export default class TableBlock extends Component {
  constructor(props) {
    super(props);

    this._handleEdit = this._handleEdit.bind(this);
    this._onModalClose = this._onModalClose.bind(this);
    this._onSave = this._onSave.bind(this);

    this.state = {
      isEditing: false,
    };

    this.actions = [
      { key: 'edit', icon: MegadraftIcons.EditIcon, action: this._handleEdit },
      {
        key: 'delete',
        icon: MegadraftIcons.DeleteIcon,
        action: this.props.container.remove,
      },
      {
        key: 'left',
        icon: Left,
        action: this.onActionModification.bind(this, { position: 'left' }),
      },
      {
        key: 'center',
        icon: Center,
        action: this.onActionModification.bind(this, { position: 'center' }),
      },
      {
        key: 'right',
        icon: Right,
        action: this.onActionModification.bind(this, { position: 'right' }),
      },
      {
        key: 'contain',
        icon: Contain,
        action: this.onActionModification.bind(this, { size: 'contain' }),
      },
      {
        key: 'cover',
        icon: Cover,
        action: this.onActionModification.bind(this, { size: 'cover' }),
      },
      {
        key: 'large',
        icon: Large,
        action: this.onActionModification.bind(this, { format: 'large' }),
      },
      {
        key: 'medium',
        icon: Medium,
        action: this.onActionModification.bind(this, { format: 'medium' }),
      },
      {
        key: 'small',
        icon: Small,
        action: this.onActionModification.bind(this, { format: 'small' }),
      },
    ];
  }

  onActionModification(modification) {
    let data = cloneDeep(this.props.data);
    data = { ...data, ...modification };
    this._onSave(data);
  }

  _handleEdit() {
    this.setState({ isEditing: true });
  }

  _onModalClose() {
    if (this.state.isEditing) {
      this.setState({ isEditing: false });
    }
  }

  _onSave(data) {
    this.setState({ isEditing: false });
    this.props.container.updateData({ ...data });
    this.props.setRefreshingState();
  }

  render() {
    const data = this.props.data || {}; //cloneDeep(this.props.data);
    const src = get(
      find(get(this.props, 'blockProps.plugin.images'), { id: data.imageMap }),
      'image'
    );
    if (!src) {
      return <span />;
    }
    return (
      <UploaderView>
        <CommonBlock {...this.props} actions={this.actions}>
          <BlockContent>
            {this.props.data ? (
              <div className="plugin-content">
                <div
                  className={`image-container ${data.format} ${
                    data.size || 'contain'
                  } ${data.position || 'center'}`}
                  style={{ backgroundImage: `url(${src})` }}
                />
              </div>
            ) : null}
          </BlockContent>
        </CommonBlock>
        <UploadManagerModal
          isOpen={this.state.isEditing}
          contentType={this.props.options.contentType}
          objectId={this.props.options.objectId}
          onCloseRequest={this._onModalClose}
          onSaveRequest={this._onSave}
          data={data}
        />
      </UploaderView>
    );
  }
}
